import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PortalSidebarComponent } from './portal-sidebar/portal-sidebar.component';
import { PortalTopbarComponent } from './portal-topbar/portal-topbar.component';

@Component({
  selector: 'app-portal-shell',
  standalone: true,
  imports: [RouterOutlet, PortalSidebarComponent, PortalTopbarComponent],
  templateUrl: './portal-shell.component.html',
})
export class PortalShellComponent {
  protected readonly sidebarCollapsed = signal(false);

  protected toggleSidebar(): void {
    this.sidebarCollapsed.update((v) => !v);
  }
}
